// Role definitions and permission map

export const ROLES = {
  owner:   { label: "Owner",   color: "#c4824a" },
  manager: { label: "Manager", color: "#6366f1" },
  staff:   { label: "Staff",   color: "#5a9e6d" },
};

// Default permissions — used when no custom permissions are saved
export const DEFAULT_PERMS = {
  manager: {
    dashboard: true, campaigns: true, research: true, integrations: true, reports: true, autopilot: true, scheduler: true, crm: true, inquiries: true,
    reservations: true, website: true, content: true, ads: true,
    social: true, gbp: true, marketing: true, reviews: true,
    bloggers: true, settings: true,
    // pricing: false, roles: false — owner only
  },
  staff: {
    dashboard: true, crm: true, inquiries: true,
    reservations: true, reviews: true, settings: true,
  },
};

// canAccess — uses custom perms if provided, falls back to defaults
export function canAccess(role, navId, customPerms) {
  if (role === "owner") return true;
  const perms = customPerms?.[role] ?? DEFAULT_PERMS[role] ?? {};
  return !!perms[navId];
}

export function canInvite(role)        { return role === "owner" || role === "manager"; }
export function canManageBilling(role) { return role === "owner"; }
export function canDeleteAccount(role) { return role === "owner"; }
export function canRemoveMember(role)  { return role === "owner"; }
export function canChangeRole(role)    { return role === "owner"; }
